import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";

import RouteNameConstants from "../constants/route-name-constants";
import { SubscriptionType } from "../models/Enums";
import { AuthService } from "./../services/auth.service";

@Injectable()
export class SubscriptionAuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const subscription = this.getSubscriptionTypeFromRoute(route);

    return this.authService.hasSubscriptionAsync(subscription).then((x) => {
      if (!x) {
        this.router.navigate([RouteNameConstants.NO_ACCESS], {
          queryParams: { returnUrl: state.url },
        });
      }
    });
  }

  private getSubscriptionTypeFromRoute(route: ActivatedRouteSnapshot): SubscriptionType {
    switch (route.url[0].path) {
      case "reminders":
        return SubscriptionType.Reminders;

      case "service-request":
        return SubscriptionType.ServiceRequest;

      case "purchase-order":
        return SubscriptionType.PurchaseOrder;

      case "contracts":
        return SubscriptionType.Contracts;

      case "tech-cover":
        return SubscriptionType.TechCover;
    }
  }
}
